import ToastLib, {
  ToastOptions,
  ToastVariant,
} from "@/components/Common/Toast/Toast";

/**
 * Lightweight hook wrapper that returns the Toast utility.
 * This is intentionally a simple accessor (no React internals) so it
 * can be used in both components and non-React service modules.
 */
export const useToast = () => {
  return ToastLib as {
    success: (message: string, options?: ToastOptions) => string;
    error: (message: string, options?: ToastOptions) => string;
    warning: (message: string, options?: ToastOptions) => string;
    info: (message: string, options?: ToastOptions) => string;
    loading: (message: string, options?: ToastOptions) => string;
    dismiss: (toastId?: string) => void;
    dismissAll: () => void;
    update: (toastId: string, message: string, variant?: ToastVariant) => void;
    promise: <T>(
      promise: Promise<T>,
      messages: {
        loading: string;
        success: string | ((data: T) => string);
        error: string | ((error: Error) => string);
      },
      options?: ToastOptions,
    ) => Promise<T>;
  };
};

/**
 * Direct getter for modules that prefer not to call a hook style function.
 */
export const getToast = useToast;

export default useToast;
